import { t } from "ttag";

import type { Credit, CreditAmount } from "@/features/referral/models";
import { Label, Popover, RadioGroup } from "@/shared/ui";

interface CreditSelectorProps {
  value?: CreditAmount;
  options: Credit["options"];
  onChange: (amount?: CreditAmount) => void;
}

export const CreditAmountSelector = ({
  value: amount,
  options,
  onChange,
}: CreditSelectorProps) => {
  return (
    <div className="flex flex-col gap-1.5">
      <Label>{t`Select amount to apply to next purchase`}</Label>

      <RadioGroup.Root
        value={amount === undefined ? "" : String(amount)}
        onClick={(e) => {
          const target = e.target as HTMLInputElement;

          if (String(amount) === target.value) {
            onChange(undefined);
          }
        }}
        onValueChange={(value) => onChange(Number(value))}
        isCard
        className="flex flex-col md:flex-row"
      >
        {options.map(({ amount, disabled, disabledReason }) => (
          <Popover.Root key={amount}>
            <Popover.Trigger asChild>
              <div className="grow text-start">
                <RadioGroup.Item disabled={disabled} value={String(amount)}>
                  <RadioGroup.Label>
                    <strong>{amount} </strong>
                    {t`credit`}
                  </RadioGroup.Label>
                </RadioGroup.Item>
              </div>
            </Popover.Trigger>

            {disabled && <Popover.Content>{disabledReason}</Popover.Content>}
          </Popover.Root>
        ))}
      </RadioGroup.Root>
    </div>
  );
};
